import { Button, ConfigProvider, Typography } from "antd";
import { WarningOutlined } from "@ant-design/icons";
import "./ErrorFallback.scss";

const { Title, Text } = Typography;

const ErrorFallback = () => {
  const handleReload = () => {
    window.location.reload();
  };

  return (
    <div className="error-fallback-container">
      <div className="error-fallback-content">
        <div className="error-fallback-icon-wrapper">
          <WarningOutlined className="error-fallback-icon" />
        </div>
        <Title level={2} className="error-fallback-title">
          Something went wrong
        </Title>
        <Text className="error-fallback-description">
          We encountered an unexpected error. Please try reloading the page.
        </Text>
        <ConfigProvider theme={{ token: { colorPrimary: "#4527a0" } }}>
          <Button
            type="primary"
            size="large"
            onClick={handleReload}
            className="error-fallback-button"
          >
            Reload
          </Button>
        </ConfigProvider>
      </div>
    </div>
  );
};

export default ErrorFallback;
